import { isTokenExpired } from "../../utils/token";
import { sessionExpiredTrue } from "../auth";

export const sessionMiddleware = (store) => {
  if (typeof window === 'undefined') return

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') return;

    const token = store.getState().auth?.accessToken
    if (!token) return;

    if (!isTokenExpired()) return;

    store.dispatch(sessionExpiredTrue());
  });
  
  return (next) => (action) => {
    return next(action);
  };
};